import { render, staticRenderFns } from "./TemplateTriggers.vue?vue&type=template&id=e4b05408"
import script from "./TemplateTriggers.vue?vue&type=script&lang=js"
export * from "./TemplateTriggers.vue?vue&type=script&lang=js"
import style0 from "./TemplateTriggers.vue?vue&type=style&index=0&id=e4b05408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports